import UserService from './user.service';

// Role-derived contexts (VO status, dawa-fund followup districts) change rarely,
// so cache them per SPA session instead of refetching on every Org visit.
const ROLE_CONTEXT_TTL_MS = 10 * 60 * 1000;
const cache = new Map(); // endpoint -> { data, at }

export async function fetchRoleContext(endpoint, { payload = {}, force = false } = {}) {
  const hit = cache.get(endpoint);
  if (!force && hit && (Date.now() - hit.at) < ROLE_CONTEXT_TTL_MS) {
    return hit.data;
  }
  const response = await UserService.authPostRequest(endpoint, payload);
  const data = response?.data?.status === 'success' ? (response.data.data || null) : null;
  // Only cache successful responses — a transient failure must not suppress
  // role-based UI (VO/followup tiles, switch list) for the whole TTL.
  if (data !== null) {
    cache.set(endpoint, { data, at: Date.now() });
  }
  return data;
}

export function clearRoleContextCache() {
  cache.clear();
}
